import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Container } from 'reactstrap';
import { toast } from 'react-toastify';
import api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import useConfig from '../../util/useConfig';
import EasyTabs from '../../shared/components/custom/EasyTabs';
import ProfileForm from './components/ProfileForm';
import TeamProfileList from './components/TeamProfileList';
import { partial } from '../../util/translation/translation';

const p = partial('ClubProfilePage');
const s = partial('shared');

const ClubProfilePage = () => {
  const config = useConfig();
  const [profile, setProfile] = useState(undefined);
  const [clubConfig, setClubConfig] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const fetchProfile = async (clubId) => {
    setLoading(true);
    try {
      const { data } = await api.clubadmin.profile.fetchProfile(clubId);
      const clubConfigResponse = await api.clubadmin.get(clubId);
      setClubConfig(clubConfigResponse.data);
      setProfile(data);
    } catch (e) {
      toast.error(e || s('somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const {
        facebook,
        instagram,
        twitter,
        youtube,
        linkedin,
        tiktok,
        ...restValues
      } = values;
      const { data } = await api.clubadmin.profile.post({
        ...restValues,
        clubId: config.id,
        imageUrl:
          restValues.imageUrl?.length > 0
            ? restValues.imageUrl[0].value
            : undefined,
      });
      // update club config here
      await api.clubadmin.update({
        id: config.id,
        teams: clubConfig.administrates,
        config: {
          ...clubConfig.config,
          socials: {
            facebook: facebook || '',
            instagram: instagram || '',
            twitter: twitter || '',
            youtube: youtube || '',
            linkedin: linkedin || '',
            tiktok: tiktok || '',
          },
        },
      });
      setProfile(data);
      setClubConfig({
        ...clubConfig,
        config: {
          ...clubConfig.config,
          socials: {
            facebook: facebook || '',
            instagram: instagram || '',
            twitter: twitter || '',
            youtube: youtube || '',
            linkedin: linkedin || '',
            tiktok: tiktok || '',
          },
        },
      });
      toast.success(p('profileUpdated'));
    } catch (e) {
      toast.error(e || s('somethingWentWrong'));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (config) {
      fetchProfile(config.id);
    }
  }, [config]);

  return (
    <Container>
      <Loading loading={loading} />
      <h3 className="page-title">{p('clubProfile')}</h3>
      <Card>
        <CardBody>
          <ProfileForm
            profile={profile}
            clubConfig={clubConfig}
            onSubmit={handleSubmit}
          />
        </CardBody>
      </Card>
    </Container>
  );
};

export default ClubProfilePage;
